import { View, Text } from '@react-pdf/renderer'
import { styles } from '../styles'
import { RatingCircle } from './RatingCircle'

export function SectionHeader({ sectionLetter, surveyLevel = 1 }) {
  return (
    <View style={styles.sectionHeader}>
      {/* Top bar with RICS branding */}
      <View style={styles.headerTopBar}>
        <Text style={styles.headerTopBarText}>
          RICS Home Survey - Level {surveyLevel}
        </Text>
      </View>

      {/* Main header row */}
      <View style={styles.headerMainRow}>
        {/* Purple section letter box */}
        <View style={styles.sectionLetterBox}>
          <Text style={styles.sectionLetter}>{sectionLetter}</Text>
        </View>

        {/* Title area */}
        <View style={styles.headerTitleArea}>
          <Text style={styles.headerTitle}>Full detail of elements inspected</Text>
        </View>

        {/* RICS text */}
        <Text style={styles.ricsText}>RICS</Text>
      </View>

      {/* Rating legend */}
      <View style={styles.ratingLegend}>
        <RatingCircle rating="1" size={20} />
        <RatingCircle rating="2" size={20} />
        <RatingCircle rating="3" size={20} />
        <RatingCircle rating="NI" size={20} />
      </View>
    </View>
  )
}

export default SectionHeader
